<template>
    <v-dialog v-model="localDialog" width="500">
        <v-card class="pa-2">
            <v-card-title>
                <h3>Theme settings</h3>
            </v-card-title>
            <v-card-text>
                <div class="d-flex flex-column">
                    <v-radio-group v-model="selectedTheme" class="ms-5">
                        <v-radio label="Dark" value="dark" color="#0090b6"></v-radio>
                        <v-radio label="Light" value="light" color="#0090b6"></v-radio>
                    </v-radio-group>
                </div>
            </v-card-text>
            <v-spacer></v-spacer>
            <div class="d-flex justify-space-between pa-3">
                <v-btn prepend-icon="mdi-magic-staff" color="primary" variant="tonal" @click="applyTheme">Apply</v-btn>
                <v-btn prepend-icon="mdi-information-outline" color="error" variant="tonal"
                    @click="closeDialog">
                    <span class="to-hide">Change later</span>
                    <span class="to-show">Later</span>
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { useTheme } from "vuetify";
import { ref, computed } from "vue";

export default {
    name: "ThemeDialog",
    props: {
        modelValue: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const theme = useTheme();
        const selectedTheme = ref(theme.global.name.value);
        
        const localDialog = computed({
            get: () => props.modelValue,
            set: (value) => emit('update:modelValue', value)
        });
        
        const applyTheme = () => {
            theme.global.name.value = selectedTheme.value;
            localStorage.setItem("theme", selectedTheme.value);
            emit('update:modelValue', false);
        };

        const closeDialog = () => {
            emit('update:modelValue', false);
        };

        return {
            theme,
            localDialog,
            selectedTheme,
            applyTheme,
            closeDialog,
        };
    },
};
</script>